import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { CtaBlock } from "@/components/CtaBlock";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { MEDICAL_PAGES } from "@/data/site";
import { api } from "@/lib/api";

export default function DispositivoMedico() {
  const entries = Object.entries(MEDICAL_PAGES);
  const [reg, setReg] = useState(null);
  useEffect(() => { api.get("/content/regulatory").then((r) => setReg(r.data)).catch(() => {}); }, []);

  return (
    <>
      <Seo title="Dispositivo medico — Normativa, agevolazioni e requisiti"
        description="SENIORCAR e il quadro normativo dei dispositivi medici: MDR, EN 12184, IVA agevolata, detrazioni fiscali, Legge 104, patente e targa."
        keywords="dispositivo medico mobilità, mdr, iva agevolata, legge 104" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Dispositivo Medico" }]} /></div>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pt-6">
        <span className="uppercase text-xs font-bold tracking-widest text-emerald-800 bg-emerald-100 px-3 py-1 rounded-full flex items-center gap-1.5 w-fit"><ShieldCheck size={14} /> Dispositivo medico</span>
        <h1 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>SENIORCAR e il quadro dei dispositivi medici</h1>
        <p className="mt-4 text-lg sm:text-xl text-slate-600 max-w-2xl">Informazioni chiare su normativa europea, standard tecnici e possibili agevolazioni. Contenuti a scopo informativo, verificati e aggiornati.</p>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {entries.map(([slug, p]) => (
            <Link key={slug} to={`/dispositivo-medico/${slug}`} className="rounded-2xl bg-white border border-slate-200 p-5 hover:shadow-md hover:-translate-y-1 transition-all group" data-testid={`medico-link-${slug}`}>
              <h3 className="text-lg font-bold text-slate-900 group-hover:text-emerald-800 leading-snug" style={{ fontFamily: "Outfit" }}>{p.title}</h3>
              <p className="mt-1.5 text-slate-600 text-sm line-clamp-2">{p.answer}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-emerald-800 font-semibold text-sm">Approfondisci <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
        {reg && (
          <div className="mt-8 rounded-xl border-l-4 p-5 text-sm text-[#6E0A2E]" style={{ background: "#FDE7EF", borderColor: "#EA155B" }} data-testid="medico-disclaimer">
            <p className="font-bold uppercase tracking-wide text-xs mb-1">Nota informativa</p>
            <p>{reg.disclaimer}</p>
            {reg.last_updated && <p className="mt-2 font-medium">Ultimo aggiornamento: {new Date(reg.last_updated).toLocaleDateString("it-IT")} · Revisione: {reg.reviewer}</p>}
          </div>
        )}
      </section>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 pb-16"><CtaBlock variant="regulatory" /></section>
    </>
  );
}
